import { render, staticRenderFns } from "./AddOrEdit.vue?vue&type=template&id=2153c596"
import script from "./AddOrEdit.vue?vue&type=script&lang=js"
export * from "./AddOrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2153c596')) {
      api.createRecord('2153c596', component.options)
    } else {
      api.reload('2153c596', component.options)
    }
    module.hot.accept("./AddOrEdit.vue?vue&type=template&id=2153c596", function () {
      api.rerender('2153c596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/division/group/AddOrEdit.vue"
export default component.exports